import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

import { MedCheckboxGroupComponent } from "./med-checkbox-group.component";
import { MedCheckboxModule } from "../med-checkbox/med-checkbox.module";

@NgModule({
  declarations: [
    MedCheckboxGroupComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MedCheckboxModule,
  ],
  exports: [
    MedCheckboxGroupComponent,
  ],
})
export class MedCheckboxGroupModule { }
